import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { BTN_ACCENT_SM } from '../lib/buttonStyles';

/**
 * «На ваше обращение ответили» — уведомление при входе.
 *
 * 🔴 Показывается ОДИН раз на непрочитанное, а не при каждой загрузке страницы.
 * Уведомление, которое повторяется на каждый F5, человек перестаёт читать за
 * день — и вместе с ним перестаёт читать настоящую новость. Правило хранится в
 * `sessionStorage`: помним, при каком числе непрочитанных уже показывали;
 * появилось новое решение — число выросло, показываем снова.
 *
 * Не модалка: она перекрывает работу и требует действия. Здесь достаточно
 * заметить и вернуться, когда удобно.
 *
 * Оформление по токенам редизайна «Бумага»
 * (`docs/redesign/2026-09-04-bumaga/HANDOFF.md`).
 */

const SHOWN_KEY = 'feedbackAnswerToastShown';
const AUTO_HIDE_MS = 12000;

/** Показывать ли уведомление: непрочитанных стало больше, чем когда показывали. */
export function shouldShow(count, shownFor) {
  if (!count || count <= 0) return false;
  const seen = Number(shownFor);
  return Number.isFinite(seen) ? count > seen : true;
}

export function readShown(storage) {
  try {
    return storage?.getItem(SHOWN_KEY);
  } catch {
    return null;   // приватный режим или запрет хранилища — просто покажем
  }
}

export function writeShown(storage, count) {
  try {
    storage?.setItem(SHOWN_KEY, String(count));
  } catch {
    /* хранилище недоступно — уведомление просто покажется ещё раз */
  }
}

export default function FeedbackAnswerToast({ count, onOpen, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, AUTO_HIDE_MS);
    return () => clearTimeout(t);
  }, [onClose]);

  const word = count === 1 ? 'обращение' : 'обращения';

  return (
    <div className="fixed bottom-6 right-6 z-40 w-[340px] p-5"
         role="status" aria-live="polite"
         style={{ background: '#fff', borderRadius: 18, boxShadow: '0 12px 32px rgba(0,0,0,.1)' }}>
      <button onClick={onClose} aria-label="Закрыть"
              className="absolute top-3 right-3 p-1" style={{ color: '#a0a0a0' }}>
        <X className="h-3.5 w-3.5" />
      </button>
      <div className="text-[14px] font-semibold text-black pr-5">
        {count === 1 ? 'На ваше обращение ответили' : `Ответили на ${count} ${word}`}
      </div>
      <div className="mt-1.5 text-[13px] leading-relaxed" style={{ color: '#5a5a5a' }}>
        Решение можно прочитать в разделе обращений.
      </div>
      <button onClick={onOpen}
              className={`mt-4 ${BTN_ACCENT_SM}`}>
        Посмотреть
      </button>
    </div>
  );
}
